import moment from 'moment';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiConstants } from '../_constants';
import { GuidLines } from './GuidLines';

export const MockTestItemForSeries = ({ mockTest, isSubscribed }) => {
  const navigate = useNavigate();
  const [showGuidLines, setShowGuidLines] = useState(false);
  // condition for subscribed or not

  const checkRetest = (item) => {
    const questionCount = parseInt(item?.mocktestcount);
    const answerCount = parseInt(item?.answercount);
    if (answerCount > 0 && answerCount >= questionCount) {
      return true;
    } else {
      return false;
    }
  };

  const checkAvailability = (mock) => {
    // const currentDate = moment.utc().startOf('day'); // Get the current date at the start of the day in UTC
    const currentDate = moment.utc(); // Get the current date at the start of the day in UTC
    const start = moment(mock?.start_date); // Convert startDate from milliseconds to moment object
    const end = moment(mock?.end_date); // Convert endDate from milliseconds to moment object

    if (currentDate.isBetween(start, end, null, '[]')) {
      const currentTime = moment.utc(); // Get the current time in UTC
      const startTime = moment(mock?.start_time); // Convert startTime from milliseconds to moment object
      const endTime = moment(mock?.end_time); // Convert endTime from milliseconds to moment object

      if (
        (currentDate.isSame(start, 'day') && currentTime.isAfter(startTime)) ||
        (currentDate.isSame(end, 'day') && currentTime.isBefore(endTime)) ||
        currentDate.isAfter(start) ||
        currentDate.isBefore(end)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return currentDate.isBetween(start, end, null, '[]'); // '[]' includes the start and end dates
    }
    // Check if current date is between start and end dates
  };

  return (
    <div className='mocktextbox'>
      <img
        src={mockTest?.image ? apiConstants.imgUrl + mockTest.image : '/img/exam_dummy.jpeg'}
        className='mocktexticon'
      />
      <div className='mocktexthead'>{mockTest?.mocktest_name}</div>
      <div className='d-flex gap-2'>
        <div className='language'>Arabic</div>
        <div className='descitem' style={{ color: '#858898' }}>
          <img src='/img/question_icon.png' className='desc_icon' /> {mockTest?.mocktestcount}{' '}
          Questions
        </div>
      </div>
      <div className='language'>
        {moment(mockTest.start_date).format('YYYY-MMM-DD')}
        {'       '},{moment(mockTest.start_time).format('hh:mm a')}
      </div>
      {isSubscribed && (
        <div className='row gap-2'>
          {checkAvailability(mockTest) && (
            <>
              {((checkRetest(mockTest) && mockTest.is_repeat) || !checkRetest(mockTest)) && (
                <div
                  className='seriesviewbtn seriesbtnlbl'
                  onClick={() => {
                    // navigate('/mocktest', { state: { mockTest: mockTest } });
                    setShowGuidLines(true);
                  }}
                >
                  Take Test
                </div>
              )}
            </>
          )}
          {checkRetest(mockTest) && (
            <div
              className='seriesviewbtn seriesbtnlbl'
              onClick={() => {
                // navigate('/mocktest', { state: { mockTest: mockTest } });
                navigate('/examresult', {
                  state: {
                    topicData: mockTest,
                    mode: 3,
                    attempt: 1,
                  },
                });
              }}
            >
              Show Result
            </div>
          )}
        </div>
      )}

      <div
        className={'modal ' + (showGuidLines ? 'show' : '')}
        id='myModal'
        onClick={() => {
          setShowGuidLines(false);
        }}
      >
        <div className='modal-content'>
          <span
            className='close'
            onClick={() => {
              setShowGuidLines(false);
            }}
          >
            &times;
          </span>
          <GuidLines
            handleClick={() => {
              navigate('/mocktest', {
                state: { mockTest: mockTest, attempt: checkRetest(mockTest) ? 2 : 1 },
              });
            }}
            GuidLines={mockTest?.guidlines}
          />
        </div>
      </div>
    </div>
  );
};
